<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader showBreadcrumbs page-title="Finance reports - expenses">
            <template #buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Get Report"
            resetToInitial
            :data="filters"
            :isLoading="isDataPageLoading"
            @submit="getReportsExpenses"
          />

          <div v-if="isDataPageLoading && isShowFilter" class="content-loading-wrapper">
            <Preloader class="centered-preloader" />
          </div>
          <TableForPage
            ref="table"
            v-if="reports.length"
            :tableData="reports"
            :fields="fieldsReports"
            :slots="slotsFieldsReports"
            :perPage="5"
            :tableDescription="columnDescription"
            showTopControls
            showTotalTable
          >
            <template v-slot:user="slotProps">
              <div class="specialist-user-name">
                {{ slotProps.item.user.name }}
              </div>
              <div class="specialist-user-position">
                {{ slotProps.item.user.position }}
              </div>
            </template>
            <template v-slot:total>
              <TableForPage
                class="table__total"
                :tableData="totalReports"
                :fields="fieldsReportsTotal"
                :perPage="totalReports.length"
              >
                <template v-slot:row>
                  <NestedTable
                    :items="totalReportsByCategories"
                    :fields="fieldsReportsTotalByCategory"
                    rowName="items"
                    :buttonShow="false"
                    :showTotalTable="false"
                  >
                  </NestedTable>
                </template>
              </TableForPage>
            </template>
            <template v-slot:row="slotProps">
              <NestedTable
                style="margin-bottom: 0;"
                :items="prepareDataForUserCategory(slotProps.row.item.items)"
                :fields="fieldsReportsUserCategory"
                :totalFields="fieldsReportsTotal"
                :modalFields="fieldsReportsExpenses"
                :modalSlots="slotsExpenses"
                :showTotalTable="false"
                rowName="items"
              >
                <template v-slot:modal-expenses_status.display_name="slotProps">
                  <LabelTableStatus :status="slotProps.item.expenses_status" />
                </template>
                <template v-slot:modal-cardDetails="slotProps">
                  <CardDescriptionTable :card="slotProps.item" />
                </template>
                <template v-slot:modal-comment="slotProps">
                  <div
                    class="d-flex justify-content-center cursor-pointer"
                    v-if="slotProps.item.comment"
                    v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
                    :title=slotProps.item.comment
                  >
                    <font-awesome-icon icon="comment" />
                  </div>
                </template>
              </NestedTable>
            </template>
          </TableForPage>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { permissions } from '@mocks/permissions'
import TableForPage from '@tables/TableForPage'
import NestedTable from '@tables/NestedTable'
import Filters from '@components/Filter/Filter'
import LabelTableStatus from '@components/tables/elements/LabelTableStatus'
import CardDescriptionTable from '@components/tables/elements/CardDescriptionTable'
import moment from 'moment'
import PageHeader from '@components/PageHeader.vue'
import Preloader from '@components/Preloader'

export default {
  components: {
    Filters,
    NestedTable,
    TableForPage,
    LabelTableStatus,
    CardDescriptionTable,
    PageHeader,
    Preloader
  },
  data () {
    return {
      permissions: permissions,
      isShowFilter: true,
      filters: {
        'date_from': {
          type: 'datepicker',
          name: 'date_from',
          label: 'Date from',
          format: 'dd/MM/yyyy',
          validation: [
            { name: 'required' }
          ],
          value: moment().subtract(1, 'months').startOf('month').toISOString(),
          defaultValue: moment().subtract(1, 'months').startOf('month').toISOString(),
          class: 'col-md-2'
        },
        'date_to': {
          type: 'datepicker',
          name: 'date_to',
          label: 'Date to',
          format: 'dd/MM/yyyy',
          validation: [
            { name: 'required' }
          ],
          value: moment().subtract(1, 'months').endOf('month').toISOString(),
          defaultValue: moment().subtract(1, 'months').endOf('month').toISOString(),
          class: 'col-md-2'
        },
        'users': {
          type: 'multiselect',
          name: 'users',
          nameItem: 'user_id',
          label: 'Users',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'expenses_statuses': {
          type: 'multiselect',
          name: 'expenses_statuses',
          nameItem: 'expense_status_id',
          label: 'Expenses statuses',
          valueField: 'id',
          selectLabel: 'display_name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'expenses_categories': {
          type: 'multiselect',
          name: 'expenses_categories',
          nameItem: 'expense_category_id',
          label: 'Expenses categories',
          valueField: 'id',
          selectLabel: 'display_name',
          options: [],
          value: [],
          class: 'col-md-2'
        }
      },
      fieldsReports: [
        /* {
          key: 'expenses_status.display_name',
          label: 'Status',
          sortable: true,
          class: 'column-date'
        }, */
        {
          key: 'user',
          label: 'Specialist',
          sortable: true,
          class: 'column-bd-name'
        },
        /* {
          key: 'user.position',
          label: 'Position',
          sortable: true,
          class: 'column-project-name'
        }, */
        {
          key: 'original.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.UAH',
          label: 'Eq UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.EUR',
          label: 'Eq EUR',
          sortable: true,
          class: 'column-amount'
        },
        /* {
          key: 'due_date',
          label: 'Due Date',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'paid_date',
          label: 'Paid Date',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'details',
          label: 'Details',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'card',
          label: 'Card',
          sortable: true,
          class: 'column-date'
        }, */
        {
          key: 'more',
          label: 'More',
          class: 'column-more'
        }
      ],
      slotsFieldsReports: {
        user: {
          name: 'user'
        }
      },
      fieldsReportsUserCategory: [
        {
          key: 'category_name',
          label: 'Category',
          sortable: true,
          class: 'column-bd-name'
        },
        /* {
          key: 'user.position',
          label: 'Position',
          sortable: true,
          class: 'column-project-name'
        }, */
        {
          key: 'original.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.UAH',
          label: 'Eq UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.EUR',
          label: 'Eq EUR',
          sortable: true,
          class: 'column-amount'
        },
        /* {
          key: 'due_date',
          label: 'due_date',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'paid_date',
          label: 'paid_date',
          sortable: true,
          class: 'column-amount'
        }, */
        /* {
          key: 'expenses_status.display_name',
          label: 'Status',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'details',
          label: 'Details',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'card',
          label: 'Card',
          sortable: true,
          class: 'column-date'
        }, */
        {
          key: 'more',
          label: 'More',
          class: 'column-more'
        }
      ],
      fieldsReportsExpenses: [
        /*
        {
          key: 'unknow',
          label: 'Position',
          sortable: true
        }, */
        {
          key: 'original.UAH',
          label: 'UAH',
          sortable: true
        },
        {
          key: 'original.USD',
          label: 'USD',
          sortable: true
        },
        {
          key: 'original.EUR',
          label: 'EUR',
          sortable: true
        },
        {
          key: 'equivalent.UAH',
          label: 'Eq UAH',
          sortable: true
        },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true
        },
        {
          key: 'equivalent.EUR',
          label: 'Eq EUR',
          sortable: true
        },
        {
          key: 'due_date',
          label: 'due_date',
          sortable: true
        },
        {
          key: 'paid_date',
          label: 'paid_date',
          sortable: true
        },
        {
          key: 'expenses_status.display_name',
          label: 'Status',
          sortable: true
        },
        {
          key: 'cardDetails',
          label: 'BANK CARD (ACCOUNT)',
          sortable: true
        },
        {
          key: 'comment',
          label: 'Comment',
          sortable: true
        }

        /* {
          key: 'bank_card.summary',
          label: 'Card',
          sortable: true
        } */
      ],
      fieldsReportsTotal: [
        {
          key: 'total_name',
          label: 'Category',
          sortable: true,
          class: 'column-bd-name'
        },
        /* {
          key: 'user.position',
          label: 'Position',
          sortable: true,
          class: 'column-project-name'
        }, */
        {
          key: 'original.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.UAH',
          label: 'Eq UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.EUR',
          label: 'Eq EUR',
          sortable: true,
          class: 'column-amount'
        },
        /* {
          key: 'due_date',
          label: 'due_date',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'paid_date',
          label: 'paid_date',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'user.status',
          label: 'Status',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'details',
          label: 'Details',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'card',
          label: 'Card',
          sortable: true,
          class: 'column-date'
        }, */
        {
          key: 'more',
          label: 'More',
          sortable: true,
          class: 'column-more'
        }
      ],
      fieldsReportsTotalByCategory: [
        {
          key: 'category_name',
          label: 'Category',
          sortable: true,
          class: 'column-bd-name'
        },
        /* {
          key: 'user.position',
          label: 'Position',
          sortable: true,
          class: 'column-project-name'
        }, */
        {
          key: 'original.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'original.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.UAH',
          label: 'Eq UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.EUR',
          label: 'Eq EUR',
          sortable: true,
          class: 'column-amount'
        }
        /* {
          key: 'due_date',
          label: 'due_date',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'paid_date',
          label: 'paid_date',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'user.status',
          label: 'Status',
          sortable: true,
          class: 'column-date'
        }, */
        /* {
          key: 'details',
          label: 'Details',
          sortable: true,
          class: 'column-date'
        } */
        /* {
          key: 'card',
          label: 'Card',
          sortable: true,
          class: 'column-date'
        } */
      ],
      slotsExpenses: {
        /* details: {
          name: 'details'
        }, */
        'expenses_status.display_name': {
          name: 'expenses_status.display_name'
        },
        'cardDetails': {
          name: 'cardDetails'
        },
        'comment': {
          name: 'comment'
        }
      },
      fieldsReportsItems: [
        {
          key: 'business_developer.name',
          label: 'Name',
          sortable: true,
          class: 'column-bd-name'
        },
        {
          key: 'project.name',
          label: 'Project Name',
          sortable: true,
          class: 'column-project-name'
        },
        {
          key: 'hours_amount',
          label: 'Hours',
          sortable: true,
          class: 'column-hours'
        },
        {
          key: 'amount.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.UAH',
          label: 'Eq UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.EUR',
          label: 'Eq EUR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'paid_date',
          label: 'Paid date',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'due_date',
          label: 'Due date',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'issue_date',
          label: 'Issue date',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'business_developer.status',
          label: 'Status',
          sortable: true,
          class: 'column-status'
        },
        {
          key: 'type_name',
          label: 'Type',
          sortable: true,
          class: 'column-type'
        },
        {
          key: 'invoice_number',
          label: 'Invoice number',
          sortable: true,
          class: 'column-number'
        },
        {
          key: 'more',
          label: 'More',
          sortable: true,
          class: 'column-more'
        }
      ],
      fieldsReportsPeriods: [
        {
          key: 'business_developer.name',
          label: 'Name',
          sortable: true,
          class: 'column-bd-name'
        },
        {
          key: 'project.name',
          label: 'Project Name',
          sortable: true,
          class: 'column-project-name'
        },
        {
          key: 'hours_amount',
          label: 'Hours',
          sortable: true,
          class: 'column-hours'
        },
        {
          key: 'amount.UAH',
          label: 'UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.USD',
          label: 'USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'amount.EUR',
          label: 'EUR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.UAH',
          label: 'Eq UAH',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.USD',
          label: 'Eq USD',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'equivalent.EUR',
          label: 'Eq EUR',
          sortable: true,
          class: 'column-amount'
        },
        {
          key: 'paid_date',
          label: 'Paid date',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'due_date',
          label: 'Due date',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'issue_date',
          label: 'Issue date',
          sortable: true,
          class: 'column-date'
        },
        {
          key: 'business_developer.status',
          label: 'Status',
          sortable: true,
          class: 'column-status'
        },
        {
          key: 'type_name',
          label: 'Type',
          sortable: true,
          class: 'column-type'
        },
        {
          key: 'invoice_number',
          label: 'Invoice number',
          sortable: true,
          class: 'column-number'
        },
        {
          key: 'more',
          label: 'More',
          sortable: true,
          class: 'column-more'
        }
      ],
      reports: [],
      totalReports: [],
      totalReportsByCategories: [],
      columnDescription: [
        '<strong>AM</strong> = ',
        '<strong>Eq</strong> = ',
        '<strong>Status</strong> = ',
        '<strong>Card</strong> = ',
        '<strong>Details</strong> = '
      ]
    }
  },
  computed: {
    ...mapGetters({
      getAllUsers: 'getAllUsers',
      getExpensesStatuses: 'getExpensesStatuses',
      getExpensesCategories: 'getExpensesCategories'
    })
  },
  created () {
    this.fetchAllData()
  },
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    fetchAllData () {
      Promise.all([
        this.fetchAllUsers(),
        this.fetchExpensesStatuses(),
        this.fetchExpensesCategories()
      ])
        .then(() => {
          this.setAllOptionsFilter()
        })
    },
    resetPagination () {
      this.$refs['table'] && this.$refs['table'].resetPagination()
    },
    getReportsExpenses (fields) {
      const data = this.prepareDataForGetReports(fields)

      this._toggleDataPageLoading(() => {
        return this.$api.finances.getReportsExpenses(data).then((res) => {
          res.data.total.byAllExpenses.total_name = 'Total:'
          this.reports = res.data.collectionByUsersAndCategories
          this.totalReportsByCategories = Object.keys(res.data.total.byCategories).map((key) => {
            return { 'category_name': key, ...res.data.total.byCategories[key] }
          })
          this.totalReports = [res.data.total.byAllExpenses]

          this.resetPagination()
        }).catch((error) => {
          if (error.response) {
            this.errorNotifications(error)
          } else {
            throw error
          }
        })
      })
    },
    prepareDataForUserCategory (fields) {
      return Object.keys(fields).map((key) => {
        return { 'category_name': key, ...fields[key] }
      })
    },
    async fetchAllUsers () {
      return this.$api.users.getAllUsers()
    },
    async fetchExpensesStatuses () {
      return this.$api.expenses.getExpensesStatuses()
    },
    async fetchExpensesCategories () {
      return this.$api.expenses.getExpensesCategories()
    },
    setAllOptionsFilter () {
      this.filters.users.options = this.getAllUsers
      this.filters.expenses_categories.options = this.getExpensesCategories
      this.filters.expenses_statuses.options = this.getExpensesStatuses
    },
    prepareDataForEditAndCreateRequest (fields) {
      let newFields = fields

      newFields.issue_date.value = this._toLocalTime(newFields.issue_date.value)
      newFields.due_date.value = this._toLocalTime(newFields.due_date.value)

      if (newFields.periods.value) {
        newFields.periods.value = fields.periods.value.map(item => {
          return {
            ...item,
            date_from: this._toLocalTime(item.date_from),
            date_to: this._toLocalTime(item.date_to)
          }
        })
      }

      let data = {}

      for (let key in newFields) {
        const name = fields[key]['name']
        data[name] = fields[key]['value']
      }

      return data
    },
    prepareDataForGetReports (fields) {
      let newFields = fields
      let data = {}

      newFields.date_from.value = this._toLocalTime(newFields.date_from.value)
      newFields.date_to.value = this._toLocalTime(newFields.date_to.value)

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Array.isArray(value)) {
          value = value.map(item => {
            return {
              [fields[key].nameItem]: item.id
            }
          })
        }

        data[name] = value
      }

      return data
    }
  }
}

</script>
